<template>
  <v-month-picker
    hide-header
    color="primary"
    :months-columns="3"
    rounded="sm"
    v-bind="$attrs"
  >
    <template #month="{ props }">
      <v-hover v-slot="{ isHovering, props: hoverProps }">
        <v-btn
          v-bind="buttonProps(props, hoverProps)"
          :rounded="
            isHovering ||
            props['aria-selected'] ||
            props['aria-current'] === 'date'
              ? 'lg'
              : true
          "
        />
      </v-hover>
    </template>
  </v-month-picker>
</template>

<script lang="ts" setup>
import { mergeProps } from "vue";

defineOptions({ name: "CelusMonthPicker", inheritAttrs: false });

const buttonProps = (
  monthProps: Record<string, unknown>,
  hoverProps: Record<string, unknown>,
) => mergeProps(monthProps, hoverProps);
</script>
